import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";

import styles from "../styles/Casos.module.scss";
import { Link } from "react-router-dom";
import CasosDesplazVer from "./componentsCasosModal/CasosDesplazVer";

import { useDispatch,  } from "react-redux";
import { casosUpdate } from "../../../store/casos/actions";
import ModalObservaciones from "./casosDesplazamiento/ModalObservaciones";
import ModalInforme from "../../Informes/ModalInforme";
import { getInformesFilterAsync } from "../../../helpers/backend";

import "../styles/grid.css";

const GridCasos = ({
  handleEspera,
  groups,
  casos,
  handleINICIADO,
  handleaddclick,
}) => {
  const [verModal, setVerModal] = useState(false);
  const [Item, setItem] = useState(false);
  const dispatch = useDispatch();
  const [informes, setInformes] = useState({}); //
  const [loading, setLoading] = useState(true);
  const handleCasoClick = (item) => {
    setVerModal(true);
    setItem(item);
  };

  // console.log(verModal)
  const handleCloseModal = () => {
    setVerModal(false);
  };

  useEffect(() => {
  
  }, [dispatch]);

  const FinalizarCasoDesplazamiento = (id) => {
    dispatch(
      casosUpdate(`${id}`, {
        estatus: "FINALIZAR",
      })
    );
  };

  const [observacionModal, setobservacionModal] = useState(false);

  const handleobservacionModal = (item) => {
    setobservacionModal(true);
    setItem(item);
  };

  const handleCloseModalObservaciones = () => {
    setobservacionModal(false);
  };


  const [InformeModal, setInformeModal] = useState(false);

  const [NumeroInforme, setNumeroInforme] = useState(false);




  const handleInforme = (informeFilter, item) => {
    setInformeModal(true);
    setNumeroInforme(informeFilter);
    setItem(item);
  };


  const handleCloseModalInforme = () => {
    setInformeModal(false);
  };

  useEffect(() => {
    if (Array.isArray(casos) && casos.length > 0) {
      const fetchInformes = async () => {
        setLoading(true); // Comienza la carga
        const informesData = {};
        for (const item of casos) {
          try {
            const response = await getInformesFilterAsync(`${item.id}/`);
            informesData[item.id] = response?.data ?? []; // Guardar solo el array `data`
          } catch (error) {
            console.error(`Error al obtener informes para el caso ${item.id}:`, error);
            informesData[item.id] = []; // Si hay error, lo tratamos como sin informes
          }
        }
        setInformes(informesData);
        setLoading(false); // Termina la carga
      };
  
      fetchInformes();
    }
  }, [casos]);
  

  return (
    <React.Fragment>
      {verModal ? (
        <CasosDesplazVer
          verModal={verModal}
          onCloseClick={handleCloseModal}
          Item={Item}
        ></CasosDesplazVer>
      ) : null}
      {observacionModal ? (
        <ModalObservaciones
          verModal={observacionModal}
          onCloseClick={handleCloseModalObservaciones}
          Item={Item}
        ></ModalObservaciones>
      ) : null}
      {InformeModal ? (
        <ModalInforme
          InformeModal={InformeModal}
          onCloseClick={handleCloseModalInforme}
          Item={Item}
          NumeroInforme={NumeroInforme}
        ></ModalInforme>
      ) : null}

      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        className="p-5 pt-2"
        id={`${styles.grid}`}
      >
        {Array.isArray(casos)
          ? casos.map((item) => {
           
              const estatusinabilit = item.estatus;
              const texto =
                item.pre_contacto === null
                  ? item.contacto !== null
                    ? item.contacto
                    : ""
                  : item.pre_contacto;

              const palabras = texto.split(" ");
              const primerasDosPalabras = palabras.slice(0, 2).join(" ");
            
              const tieneInformes = Array.isArray(informes[item.id]) && informes[item.id].length > 0;
              return (
                <Grid item md={4} key={item.id}>
                  
                  <div
                    className={`${styles.card}`}
                    style={{ pointerEvents: "none" }}
                  >
                    <div className={`${styles["card-details"]}`}>
                      {item.modelo_desplazamiento === true ? (
                        <>
                          {/* Casos que  son de desplazamiento */}
                          <h3
                            className="text-primary"
                            style={{ pointerEvents: "auto" }}
                            onClick={() => handleCasoClick(item)}
                          >
                            Caso Desplaz. #{item.id}
                          </h3>

                          <div className="text-primary mb-6">
                            <strong>Ir de : </strong>{" "}
                          </div>

                          <div>{item.direccion_1}</div>

                          <div className="text-primary mb-6">
                            <strong>Hacia :</strong>{" "}
                          </div>
                          <div>{item.direccion_2}</div>

                          <div className="text-primary mb-6">
                            <strong> Asignado A</strong>{" "}
                          </div>
                          <div>{item.tecnico_asignado}</div>

                          <div className="text-primary mb-6">
                            <strong>Estatus</strong>{" "}
                          </div>
                          {item.estatus === "ACEPTAR" ? (
                            <div className="badge rounded-pill bg-danger  fontSize-13">
                              <strong>ACEPTADO</strong>
                            </div>
                          ) : item.estatus === "INICIAR" ? (
                            <div
                              className="badge rounded-pill bg-dark
                                                    fontSize-13"
                            >
                              <strong>INICIADO</strong>
                            </div>
                          ) : item.estatus === "ASIGNADO" ? (
                            <div className="badge rounded-pill bg-warning  fontSize-13">
                              <strong>ASIGNADO</strong>
                            </div>
                          ) : item.estatus === "PAUSAR" ? (
                            <div className="badge rounded-pill bg-secondary  fontSize-13">
                              <strong>PAUSADO</strong>
                            </div>
                          ) : item.estatus === "FINALIZAR" ? (
                            <div className="badge rounded-pill bg-success fontSize-13">
                              <strong>FINALIZADO</strong>
                            </div>
                          ) : item.estatus === "EN ESPERA" ? (
                            <div className="badge rounded-pill bg-info fontSize-13">
                              <strong>EN ESPERA</strong>
                            </div>
                          ) : item.estatus === "REINICIAR" ? (
                            <div className="badge rounded-pill bg-info fontSize-13">
                              <strong>REINICIADO</strong>
                            </div>
                          ) : null}

                      <div className={`mt-2 ${styles["btn-Caso-Desplazamiento"]}` }>
                            {item.estatus === "INICIAR" ||
                            item.estatus === "REINICIAR" ? (
                              <button
                                className={`btn btn-sm  btn-secondary  ${styles["btn-pausar"]}`}
                                style={{
                                  marginRight: "10px",
                                  pointerEvents:
                                    estatusinabilit === "FINALIZAR" &&
                                    item.estatus !== "EN ESPERA"
                                      ? "none"
                                      : "auto",
                                }}
                                onClick={() => {
                                  handleobservacionModal(item);
                                }}
                              >
                                PAUSAR
                              </button>
                            ) : null}

                            {estatusinabilit !== "FINALIZAR" ? (
                              <button
                                className="btn btn-sm btn-primary waves-effect waves-light "
                                id="disabled"
                                style={{
                                  pointerEvents:
                                    estatusinabilit === "FINALIZAR" &&
                                    item.estatus !== "EN ESPERA"
                                      ? "none"
                                      : "auto",
                                }}
                                onClick={(e) =>
                                  item.estatus === "EN ESPERA"
                                    ? handleEspera(item.id)
                                    : item.estatus === "INICIAR" ||
                                      item.estatus === "REINICIAR"
                                    ? FinalizarCasoDesplazamiento(item.id)
                                    // : handleaddclick(item.id)
                                    : handleaddclick(item)
                                }
                                disabled={
                                  estatusinabilit === "FINALIZAR" ||
                                  (groups === "SuperAdmin" &&
                                    item.estatus !== "EN ESPERA")
                                    ? true
                                    : false
                                }
                                // disabled={false}
                              >
                                {item.estatus === "FINALIZAR"
                                  ? "FINALIZADO"
                                  : item.estatus === "ASIGNADO"
                                  ? "ACEPTAR"
                                  : item.estatus === "ACEPTAR"
                                  ? "INICIAR"
                                  : item.estatus === "EN ESPERA"
                                  ? "ASIGNAR"
                                  : item.estatus === "PAUSAR"
                                  ? "REINICIAR"
                                  : item.estatus === "INICIAR"
                                  ? "FINALIZAR"
                                  : item.estatus === "REINICIAR" &&
                                    item.modelo_desplazamiento === false
                                  ? "PAUSAR"
                                  : item.estatus === "REINICIAR" &&
                                    item.modelo_desplazamiento === true
                                  ? "FINALIZAR"
                                  : ""}
                              </button>
                            ) : null}
                          </div>
                        </>
                      ) : (
                        <>
                          {/* Casos que no son de desplazamiento */}
                          <Link to={`/casos/${item.id}/edit_caso`}>
                            <h3
                              className="text-primary"
                              style={{ pointerEvents: "auto" }}
                            >
                              Caso #{item.id}
                            </h3>{" "}
                          </Link>
                          <div className="text-primary mt-3 ">
                            <strong> Contacto :{primerasDosPalabras}</strong>
                          </div>

                          <div className="text-primary mb-6">
                            <strong>Estatus</strong>{" "}
                          </div>
                          {item.estatus === "ACEPTAR" ? (
                            <div className="badge rounded-pill bg-danger  fontSize-13">
                              <strong>ACEPTADO</strong>
                            </div>
                          ) : item.estatus === "INICIAR" ? (
                            <div
                              className="badge rounded-pill bg-dark
                                                    fontSize-13"
                            >
                              <strong>INICIADO</strong>
                            </div>
                          ) : item.estatus === "ASIGNADO" ? (
                            <div className="badge rounded-pill bg-warning  fontSize-13">
                              <strong>ASIGNADO</strong>
                            </div>
                          ) : item.estatus === "PAUSAR" ? (
                            <div className="badge rounded-pill bg-secondary  fontSize-13">
                              <strong>PAUSADO</strong>
                            </div>
                          ) : item.estatus === "FINALIZAR" ? (
                            <div className="badge rounded-pill bg-success fontSize-13">
                              <strong>FINALIZADO</strong>
                            </div>
                          ) : item.estatus === "EN ESPERA" ? (
                            <div className="badge rounded-pill bg-info fontSize-13">
                              <strong>EN ESPERA</strong>
                            </div>
                          ) : item.estatus === "REINICIAR" ? (
                            <div className="badge rounded-pill bg-info fontSize-13">
                              <strong>REINICIADO</strong>
                            </div>
                          ) : null}

                          {item.estatus !== "EN ESPERA" ? (
                            <>
                              <div className="text-primary mb-6">
                                <strong>
                                  Fecha de asignacion: {item.fecha_asignacion}
                                </strong>{" "}
                              </div>

                              <div className="text-primary mb-6">
                                <strong>
                                  Hora de Entrada: {item.lapso_hora_entrada}
                                </strong>{" "}
                              </div>

                              <div className="text-primary mb-6">
                                <strong>
                                   Asignado a:{" "}
                                  {item.tecnico_asignado.join(", ")}
                                </strong>{" "}
                              </div>
                            </>
                          ) : null}
                           
                       
                        
                            { groups !== "SuperAdmin" ?(

                          <div>
                            {item.estatus === "INICIAR" ? (
                        !loading && (
                          <button
                            className="btn btn-primary waves-effect waves-light mt-2"
                            onClick={() => handleInforme(informes[item.id], item)}
                            style={{
                              pointerEvents:
                                estatusinabilit === "FINALIZAR" && item.estatus !== "EN ESPERA"
                                  ? "none"
                                  : "auto",
                            }}
                          >
                            {informes[item.id]?.length > 0 ? "Editar Informe" : "Crear Informe"}
                          </button>
                        )
                        
                          
                            ) : estatusinabilit !== "FINALIZAR" ? (
                              <button
                                className="btn btn-primary waves-effect waves-light mt-2"
                                id="disabled"
                                style={{
                                  pointerEvents:
                                    estatusinabilit === "FINALIZAR" &&
                                    item.estatus !== "EN ESPERA"
                                      ? "none"
                                      : "auto",
                                }}
                                onClick={(e) =>
                                  item.estatus === "EN ESPERA"
                                    ? handleEspera(item.id)
                                    : item.estatus === "INICIAR"
                                    ? handleINICIADO(item.id)
                                    // : handleaddclick(item.id)
                                    : handleaddclick(item)
                                }
                                disabled={
                                  estatusinabilit === "FINALIZAR" ||
                                  (groups === "SuperAdmin" &&
                                    item.estatus !== "EN ESPERA")
                                    ? true
                                    : false
                                }
                                // disabled={false}
                              >
                                {item.estatus === "FINALIZAR"
                                  ? "FINALIZADO"
                                  : item.estatus === "ASIGNADO"
                                  ? "ACEPTAR"
                                  : item.estatus === "ACEPTAR"
                                  ? "INICIAR"
                                  : item.estatus === "EN ESPERA"
                                  ? "ASIGNAR"
                                  : ""}
                              </button>
                            ) : null}
                          </div>
                            ):null}

                           
                        </>
                      )}
                    </div>
                  </div>
                </Grid>
              );
            })
          : []}
      </Grid>
    </React.Fragment>
  );
};

export default GridCasos;
